<header class="header-container" [ngClass]="{'header-container-custom-h' : isCustom && isHeaderBreakpoint, 'header-container-brixen-h' : isCustom && isHeaderBreakpoint && customHeader?.domain === 'brixen'}">
  <div class="header-default-bg" [ngClass]="{'header-content-height' : isCustom}"
    [ngStyle]="{'background': isCustom ? customHeader.header.headerColor : defaultBgColor}"></div>
  <div class="header-content" [ngClass]="{'header-content-border' : !isCustom,'header-content-custom': isCustom, 'header-content-brixen': isCustom && customHeader?.domain === 'brixen'}">
    <div class="content-fr1">
      @if (!isCustom) {
        <img [src]="areaImage ? areaImage : 'assets/images/logos/logoCTnew.png'"
          (click)="onLogoClick(areaImage ? false : true)"
          [ngClass]="{'pointer' : !areaImage && !areInPrRoutes}"
          class="default-header-logo">
      } @else{
        <div class="d-flex align-items-center">
          <img routerLink="/home" [src]="customHeader.header.mainIcon" class="custom-header-logo my-5 cursor-pointer" [ngClass]="{'logo-potenzacalcio': customHeader.domain === 'potenzacalcio'}">
          @if (customHeader?.customText) {
              <h5 class="custom-header-text mb-0" style="width: fit-content !important;"[ngClass]="{'mr-10' : !isSmallScreen }">{{customHeader.customText}}</h5>
          }
        </div>
      }
      @if (isHeaderBreakpoint) {
        <div class="d-flex align-items-center ml-auto">
          @if (isLoggedin && isUserPR && !isCustom) {
            <div class="mr-20 d-flex align-items-center">
              <img style="object-fit: contain;" (click)="navigateToPr()" [src]="'assets/images/pr.svg'">
            </div>
          }
          <app-menu
            [isHeaderBreakpoint]="isHeaderBreakpoint"
            [isLoggedin]="isLoggedin" 
            [isCustom]="isCustom"
            [isSmallScreen]="isSmallScreen">
          </app-menu>
        </div>
      }
    </div>
    @if (!isHeaderBreakpoint) {
      <div class="content-fr2">
        @if (!hideSearchBar) {
          <app-search-bar
            [isCustom]="isCustom"
            [isHeaderBreakpoint]="isHeaderBreakpoint">
          </app-search-bar>
        }
      </div>
      <div class="content-fr3">
        @if (isLoggedin) {
          @if(!isCustom) {
            <div class="d-flex align-items-center" style="width: max-content;">
              @if (isUserPR) {
                <div class="pr-account-icon orange-shadow" (click)="navigateToPr()">PR</div>
              } @else {
                <div class="account-icon">
                  <img src="assets/images/user.svg"  (click)="navigateToUserDashboard()" class="account-icon-svg" alt="">
                </div>
              }
              <div class="flex-column ml-10" style="cursor: pointer" (click)="isUserPR ? navigateToPr() : navigateToUserDashboard()">
                @if (bearerUser?.trim()) {
                  <span class="fz-14 fw-400" style="color: #004580; line-height: 120%;"> {{'general.hello' | translate}}, </span>
                  <span class="fz-14 fw-400" style="color: #004580; line-height: 120%">{{ bearerUser }}</span>
                }
              </div>
            </div>
          }
            <app-cart-summary
              [isHeaderBreakpoint]="isHeaderBreakpoint"
              [isSmallScreen]="isSmallScreen"
              [isCustom]="isCustom"
              [customDataPage]="customHeader">
            </app-cart-summary>
        } @else {
          <div class="auth-buttons-container d-flex align-items-center">
            <div class="auth-btn" (click)="onLoginClick()">
              {{ (isCustom ? 'general.login_popup_button' : 'general.login') | translate }}
            </div>
            <div class="auth-divider"></div>
            <div class="auth-btn" routerLink="/registrati">
              {{ 'general.register_popup_button' | translate }}
            </div>
          </div>
        }
        <app-menu
          [isHeaderBreakpoint]="isHeaderBreakpoint"
          [isLoggedin]="isLoggedin">
        </app-menu>
      </div>
    }
    @if (isHeaderBreakpoint) {
      <div class="content-fr4 pt-10">
        <div style="flex: 1 1 100%">
          @if (!hideSearchBar) {
            <app-search-bar
              [isCustom]="isCustom"
              [isHeaderBreakpoint]="isHeaderBreakpoint">
            </app-search-bar>
          }
        </div>
        @if (isLoggedin) {
          <app-cart-summary
            [isCustom]="isCustom"
            [customDataPage]="customHeader"
            [isHeaderBreakpoint]="isHeaderBreakpoint"
            [isSmallScreen]="isSmallScreen">
          </app-cart-summary>
        }
      </div>
    }
  </div>
</header>